import { instance } from '@payments-checkout/shared/helpers/index';
import { useSessionId } from '@payments-checkout/shared/providers';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'next/navigation';
import { MerchantData } from '../../types';

export const sendApplePayConfig = async (
  paymentLinkId: string,
  sessionId?: string
): Promise<MerchantData> => {
  if (!sessionId) throw new Error('SessionId is required');

  const response = await instance.post(
    `paymentlinks/${paymentLinkId}/sessions/${sessionId}/apple-pay`
  );
  return response.data;
};

export const useMerchantData = () => {
  const params = useParams<{ paymentLinkId: string }>();
  const { sessionId } = useSessionId();

  return useQuery<MerchantData>({
    queryKey: ['apple-pay', params.paymentLinkId, sessionId],
    queryFn: () => sendApplePayConfig(params.paymentLinkId, sessionId),
    enabled: !!sessionId && !!params.paymentLinkId,
  });
};
